<template>
  <div class="terms">

    <!-- privacy & terms -->
    <div class="pt-tank">
      <p class="pt-tit">{{pageData.tit}}</p>
      <div class="pt-intro" v-html="pageData.intro" />
      <div class="pt-main">
        <div v-for="(item, index) in pageData.list" :key="index">
          <p class="bold"><span class="num">{{index+1}}.</span>{{item.tit}}</p>
          <div class="bold first-con" v-show="item.con">{{item.con}}</div>
          <el-button v-if="pageData.key==='privacy'" class="fold-btn" @click="toggleFold(index)">{{item.is_fold?'Collapse':'Expand'}}<i class="el-icon-arrow-down btn-icon" :class="item.is_fold?'active-icon':''" /></el-button>
          <div ref="foldTank" class="fold-tank">
            <div v-for="(sec, secIndex) in item.sec_list" :key="secIndex" :class="(item.is_fold||pageData.key==='terms')?'active-fold':'hidden-fold'">
              <p :id="sec.ref?sec.ref:''" class="sec-con" v-html="sec.con" />
              <template v-if="sec.third_list">
                <div v-for="(third, thirdIndex) in sec.third_list" :key="thirdIndex">
                  <p class="third-con" v-html="third.con" />
                  <template v-if="third.fourth_list">
                    <p v-for="(fourth, fourthIndex) in third.fourth_list" :key="fourthIndex" v-html="fourth.con" class="fourth-con" />
                  </template>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <p ref="test">{{$route.query.name==='privacy'?'This Privacy Statement (Version 1) is published on 1st January 2021':'Last updated version: Version 1 dated 1 January 2021'}}</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      privacyData: {
        tit: 'Widi’s Privacy Statement',
        intro: 'By accepting this Privacy Statement in the registration process or by using our Website or Services, you expressly agree to the terms under this Privacy Statement and consent to our collection, use, transfer and disclosure of your Personal Data in accordance with this Privacy Statement. This Privacy Statement is incorporated into and subject to our Terms of Service. Capitalised terms used but not defined herein shall have the meanings ascribed to them in the Terms of Service.<br/><br/> This is the Privacy Statement of Widi Pte Limited (together with our affiliates and subsidiaries, “<b>Widi</b>”, “we”, “us” or “our” and terms of similar meaning) and our related software, products, services (the “<b>Services</b>”) and our website (www.widi.com)(the “<b>Website</b>”).<br/><br/> This Privacy Statement provides an overview on how we collect, process, transfer and disclose the Personal Data in our Website and in the course of providing our Services to you in accordance with the applicable data protection law, the Personal Data (Privacy) Ordinance (Cap. 486) of the Hong Kong laws (the “<b>PDPO</b>”). ',
        key: 'privacy',
        list: [
          {
            tit: 'What data do we collect? ',
            con: 'We tell you what data we will collect from you: Personal Data You Provide, that include your own Personal Data, Personal Data of Others and Audit Data, and Internet Data. Please do not provide us any Sensitive Personal Data. ',
            is_fold: false,
            sec_list: [
              {
                con: '1.1 &nbsp;&nbsp; Personal Data You Provide. When you visit our Website and use our Services, we may collect (a) your Personal Data, Personal Data of others provided by you and audit data:- ',
                third_list: [
                  {
                    con: '(a) 	Your Personal Data. We may collect personal data that can be used to contact or identify you and may include data such as your full name, email address, telephone number, bank account details, taxation details, and accounting and financial data or any data that may be able to identify you directly or indirectly (“<b>Personal Data</b>”):- ',
                    fourth_list: [
                      {
                        con: '(i) 	When you choose to use our Services, you are required to register an account or add a User to an account, we collect the Personal Data, such as the name of your company, your full name, your phone number, credit card, or other billing information, your email address and business postal addresses. '
                      },
                      {
                        con: '(ii) 	When you invite others to use the Services, you provide us with Personal Data of others and consent that we are allowed to use those Personal Data to contact such persons. We may also receive Personal Data through other users, for example, if they have tried to give you access to the Services or refer our Services to you.'
                      },
                      {
                        con: '(iii)	It is your responsibility to provide us with up-to-date and accurate Personal Data in order to use the Services. '
                      },
                      {
                        con: '(iv) 	If the required Personal Data for the purpose of registration is not provided or you do not consent to provide or permit us to process or use your Personal Data, we are unable to provide our Services to you. '
                      }
                    ]
                  },
                  {
                    con: '(b) 	Personal Data of Others. If you provide Personal Data of others, you must ensure and agree that you are authorised and have obtained sufficient consent to disclose such Personal Data to us and that, without requiring us to take further steps under any applicable data protection laws in any jurisdictions. You must take reasonable step to ensure that such individual is aware of and consents to the various matters under this Privacy Statement, including the fact that that person’s Personal Data is being collected, the purposes for which that Personal Data is being collected, the intended recipient of his Personal Data, our identity and how to contact us. '
                  },
                  {
                    con: '(c) 	Audit Data. We collect, process and store the data related to audits that you provide us in connection with using the Services for the purposes of fulfilling your audit obligations under the applicable laws (the “<b>Audit Data</b>”). '
                  }
                ]
              },
              {
                con: '1.2 &nbsp;&nbsp;	Internet Data. When you visit our Website or use our Services, we may collect the behavioral data and general internet data, including your internet protocol ("<b>IP</b>") address, metadata, location data, date and time you visit:- ',
                third_list: [
                  {
                    con: '(a) 	A "cookie" is also set on your computer or mobile phone to allow us to recognize you whenever you visit and collect information, like the pages you visit and the preferences you choose. We use the information we collect for statistical purposes and to study how our Website is used so that we may improve and enhance your experience on our Website. We may provide such information collected to outside vendors located within or outside Hong Kong SAR for such purposes. No Personal Data is stored in cookies. It is possible for you not to accept our cookies while using our Website by setting the preference in your web browser. If you do so, you may not be able to use some functions of the Services or Website. If you would like more information about cookies, you can visit <a href="http://www.cookiecentral.com/n_cookie_faq.htm" target="_blank">http://www.cookiecentral.com/n_cookie_faq.htm</a>. We use two different types of cookies. One type of cookie is used so that our Website or our Services "recognizes" you each time you return using the same device, and you do not have to re-enter all your Personal Data on each visit. You can set your web browser to refuse to accept this cookie, or delete this type of cookie from your hard drive, and still access our products and services, as long as you re-enter information each time you visit. The second type of cookie is needed so that we can process each step of your transactions with us. If you refuse to accept this type of cookie, you will not be able to access our Services. Most web browsers automatically delete this type of cookie when you terminate your session;'
                  },
                  {
                    con: '(b) 	We may use third-party advertising companies inside and outside of Hong Kong to serve ads on our Website. These companies may employ cookies and action tags (also known as single pixel gifs or web beacons) to measure advertising effectiveness; and they are not authorized to use the information we share with them for any other purpose. Any information that these third parties collect via cookies and action tags is completely anonymous .In the event you indicate that you want to receive offers from us, your information may be used to serve relevant ads to you when you visit the Website and to send you personalized offers; '
                  },
                  {
                    con: '(c) 	We may use Google Analytics or other similar analytical tools to obtain information collected in order to display, optimize and personalize advertisements and customer experience on our web properties that are designed to bring visitors to our Website, to determine which advertisements you may find useful, and to personalize your experience on our Website. We may also use this information to segment, enhance or modify our advertisements and to personalize your experience; '
                  },
                  {
                    con: '(d) 	Anonymous Data. In order to enhance the usefulness of our Website and our Services, we will collect data about your use of our Website or Services, in a manner that does not include any personally identifiable information. While you browse our Website or use our Services, we note which pages of our Website or our Services you visit and note the IP address of your devices (as all websites do automatically), but we do not link that address data to your Personal Data. The general information we gather enables us to serve you better by continually enhancing our Website or our Services based on up-to-date use patterns. We are provided anonymous information collected from other web sites on which we display advertisements that enables us to understand how visitors to our Website, who were exposed to ads we have placed on those other web sites, interact with our Website or Services. We may use this information to enhance or modify our campaigns that are designed to bring web visitors to our Website or Services. You may opt-out of this anonymous data collection and sharing activity by visiting the Google Analytics Privacy Overview web page and following the procedures noted under the Browser Opt-Out and Privacy Center information sections (search for these sites through <a href="https://www.google.com" target="_blank">www.google.com</a>); and/or '
                  },
                  {
                    con: '(e) 	Behavioral Data. Behavioral data is one of the information which we may use to serve you with personalized offers of our Services and our trusted partners. This data includes your interaction with our Services and our Website including but not limited to information searched, transaction conducted, purchase history etc. The data we gather is to enhance the relevancy of the personalized offers. '
                  }
                ]
              },
              {
                con: '1.3 &nbsp;&nbsp;	Sensitive Personal Data. Sensitive Personal Data is defined as data which reveals racial or ethnic origin, political opinions, religious or philosophical beliefs, or trade union membership, and the processing of genetic data, biometric data for the purpose of uniquely identifying a natural person, data concerning health or data concerning a natural person’s sex life or sexual orientation. You are prohibited from upholding any Sensitive Personal Data about yourself or others in the course of using our Services or to our Website. '
              }
            ]
          },
          {
            tit: 'How do we use the data? ',
            con: 'We will use the data you provide or the Internet Data for certain purposes, including but not limited to the purposes of providing services to you, improving our Services, analytics, research or statistics etc. ',
            is_fold: false,
            sec_list: [
              {
                con: '2.1 &nbsp;&nbsp;	We will use the data we collected to: ',
                third_list: [
                  {
                    con: '(a) 	to provide and improve our Services and Website; '
                  },
                  {
                    con: '(b) 	to administer your use of the Services and Website; '
                  },
                  {
                    con: '(c) 	to personalise and improve your experience in using our Services and Website; '
                  },
                  {
                    con: '(d) 	to provide or offer updates and announcements from us. You have the right to unsubscribe to any communications with us by contacting us at <a href="mailto:support@thewidi.com">support@thewidi.com</a>; '
                  },
                  {
                    con: '(e) to disclose to our service providers; '
                  },
                  {
                    con: '(f) 	to comply with our legal obligations; '
                  },
                  {
                    con: '(g) 	to protect of individual’s vital interests; and'
                  },
                  {
                    con: '(h) 	to disclose when necessary for Widi’s legitimate interests, as long as such interests are not overridden by the interests, rights and freedoms with respect to your Personal Data. '
                  }
                ]
              },
              {
                con: '2.2 &nbsp;&nbsp; Analytics, Research or Statistics. We use Internet Data (ourselves or using third party services) which can sometimes be correlated with Personal Data. We use this for the purposes stated above and to monitor and analyse the use of our Services and Website for the technical administration, to increase our Service’s functionality and user-friendliness, and to verify users have the authorization needed for the Service to process their requests. We may use Google Analytics for these purposes as stated in this Privacy Statement. '
              },
              {
                ref: 'privacy_sec_point',
                con: '2.3 &nbsp;&nbsp;	Direct Marketing. Widi may only use your Personal Data for the direct marketing purpose if you give us your consent. You may opt-in during the online ordering process by ticking the opt-in box that states,<br/><br/><i>“Please send me tips, news, special offers of Widi’s services and products!” </i><br/><br/>If you decide to receive our tips and news, special offers or personalized offers from us and our trusted partners, Widi may use your Personal Data, including your name, contact details (email etcs), products and other service portfolio information, transaction pattern and behaviour, financial background and demographic data held by us from time to time, to contact you and to transfer them to our authorized agent in or outside Hong Kong for direct marketing of Widi’s products or services including but not limited to marketing materials, special offers, discounts, and tips our Widi’s services and products. <br/><br/>In case you no longer want to receive our tips, news and special offers, you may opt-out of receiving them by clicking the “Unsubscribe” button at the bottom of the email. Alternatively, you may go to our Website log-in, click on your profile, and de-select the opt-in box for our tips, news and special offers.'
              }
            ]
          },
          {
            tit: 'With/ To whom we share or transfer your data? ',
            con: 'We may share or transfer the data you provide or Internet Data to others according to your instructions to other users of your account, our service providers, business partners, law enforcement agencies or government authorities under certain circumstances and acquirers of our businesses. ',
            is_fold: false,
            sec_list: [
              {
                con: '3.1 &nbsp;&nbsp;	Your Use. Unless you specified otherwise, Audit Data and Personal Data that you provide to us may be shared with other users that are connected to your account. Under no circumstances will we sell your Audit Information or Personal Information to third parties.'
              },
              {
                con: '3.2 &nbsp;&nbsp;	Service Providers, Business Partners and Others. We may use certain trusted third party companies and individuals to help us provide, analyze, and improve the Service (including but not limited to data storage, maintenance services, database management, web analytics, payment processing, and improvement of the Service’s features). These third parties may have access to data you provide to us or Internet Data only for purposes of performing these tasks on our behalf and under obligations similar to those in this Privacy Policy. '
              },
              {
                con: "3.3 &nbsp;&nbsp;	Compliance with Laws and Law Enforcement Requests; Protection of Widi's Rights. We may disclose to parties outside Widi the internet data or the data that you provide and that we collect when we have a good faith belief that disclosure is reasonably necessary to (a) comply with a law, regulation, court order or compulsory legal request; (b) protect the safety of any person from death or serious bodily injury; (c) prevent fraud or abuse of Widi or its users; or (d) to protect Widi’s property rights. "
              },
              {
                con: "3.4 &nbsp;&nbsp;	Business Transfer or acquisition. In the event of a business transfer or an acquisition of all or part of Widi by another company, or in the event that Widi were to sell or dispose of all or a part of the business, the acquirer would have access to the information maintained by the Widi business, which could include your personal information, subject to applicable law. The acquirer's privacy practice might be different from Widi’s privacy practices, or the acquirer might choose to amend this Privacy Statement. You will be notified by email if, as a result of such acquisition, the Privacy Statement is materially changed or if the acquirer's privacy practices are materially different from this Privacy Statement and Widi's privacy practices. In connection with such notice, you will be given an opportunity to inform the acquirer that you do not consent to the use or disclosure by the acquirer of your personal information in accordance with such a new or revised privacy statement. "
              },
              {
                con: '3.5  &nbsp;&nbsp;	Aggregated Data & Statistics. We may disclose aggregated data or statistics of the internet data or the data you provide to us which does not identify any data subjects to other third parties. '
              }
            ]
          },
          {
            tit: 'International Data Transfer ',
            con: 'You consent and authorise the transfer of the data you provide to us outside Hong Kong to be processed and stored. ',
            is_fold: false,
            sec_list: [
              {
                con: 'We store and process the data you provide to us and the Internet Data in our Amazon’s AWS located in Singapore. You agree and authorise such cross-border data transfer. You acknowledge that the level of protection to the data you provide to us under the applicable data protection laws in Singapore may be different from the protection under the PDPO and the laws of Hong Kong. '
              }
            ]
          },
          {
            tit: 'How do we protect your data? ',
            con: 'We adopt technical and organisational measures to protect your data including but not limited to using encryption technology in data transmission.',
            is_fold: false,
            sec_list: [
              {
                con: '5.1 &nbsp;&nbsp;	Widi has in place strong technical and organisational measures to protect against unauthorised, unlawful or accidental processing, destruction, loss, alteration, disclosure of, or access to Personal Data. '
              },
              {
                con: "5.2 &nbsp;&nbsp;	We process and store the internet data and the data you provide to us Data is stored and processed on Amazon's AWS. You can read more about AWS security and compliance <a href='https://docs.aws.amazon.com/whitepapers/latest/aws-overview/security-and-compliance.html' target='_blank'>here</a>. "
              },
              {
                con: '5.3 &nbsp;&nbsp;	A minimum of 256-bit AES is used for encryption at rest and transmission. Our employees processing data are subject to a duty of confidence and we perform data protection risk assessments as required to ensure that all customer data is appropriately protected. '
              }
            ]
          },
          {
            tit: 'How do we store your Personal Data? ',
            con: 'We store your data as long as necessary and in compliance with the laws of Hong Kong and the local law where our servers are located. ',
            is_fold: false,
            sec_list: [
              {
                con: '6.1 &nbsp;&nbsp;	We will retain your Personal Data only as long as necessary to fulfill the terms of our Service contract with you, and comply with applicable law. '
              },
              {
                con: '6.2 &nbsp;&nbsp;	We store the internet data and the data you provide to us on Amazon’s AWS located in Singapore. All data are processed and stored in compliance with the local data protection laws. '
              }
            ]
          },
          {
            tit: 'What rights do you have? ',
            con: 'You have different rights to your Personal Data and you may withdraw your consent at any time. Should you have any enquiries in relation to your Personal Data, you may contact our Data Protection Office or file a complaint to the relevant data protection authorities.',
            is_fold: false,
            sec_list: [
              {
                con: '7.1 &nbsp;&nbsp;	You have the following rights to:- ',
                third_list: [
                  {
                    con: '(a) 	access the Personal Data we maintain about you; '
                  },
                  {
                    con: '(b) 	be provided with information about how we process your Personal Data; '
                  },
                  {
                    con: '(c) 	correct your Personal Data; '
                  },
                  {
                    con: '(d) 	have your Personal Data erased; '
                  },
                  {
                    con: '(e) 	object to or restrict how we process your Personal Data; and '
                  },
                  {
                    con: '(f) 	request your Personal Data to be transferred to a third party. '
                  },
                  {
                    con: 'To exercise the above rights, please contact us at the information we provide below. We will consider and process your request within a reasonable period of time. '
                  }
                ]
              },
              {
                con: '7.2 &nbsp;&nbsp;	How to Withdraw Your Consent?',
                third_list: [
                  {
                    con: 'At any time, you may withdraw consent you have provided to Widi for using, disclosing, or otherwise processing your Personal Data. You may withdraw your consent by emailing <a href="mailto:support@thewidi.com">support@thewidi.com</a>, and following the instructions in our communication to you. Please note that your withdrawal of consent to process certain Personal Data about you (a) may limit our ability to deliver our Services to you; and (b) does not affect the lawfulness of our processing activities based on your consent before its withdrawal. '
                  }
                ]
              },
              {
                con: '7.3 &nbsp;&nbsp;	You may file a complaint regarding this Privacy Statement or our privacy practices by contacting our Data Protection Office at <a href="mailto:support@thewidi.com">support@thewidi.com</a> or file a complaint with the Office of Privacy Commissioner of the Personal Data (“<b>PCPD</b>”) at <a href="https://www.pcpd.org.hk/english/complaints/how_complaint/complaint/complaint.html" target="_blank">https://www.pcpd.org.hk/english/complaints/how_complaint/complaint/complaint.html</a> . '
              }
            ]
          },
          {
            tit: 'Policy Regarding Children ',
            con: 'No individual under 18 should use our Services or Website. Please do not provide any personal data of any children to us. ',
            is_fold: false,
            sec_list: [
              {
                con: 'We define children as individuals under the age of 18. Our Website or Services is not intended for the use of children and we do not intend to collect information about children through our Website or in the course of providing our Services to you. You must be at least 18 to access any Services or use of our Website. '
              }
            ]
          },
          {
            tit: 'Changes to this Privacy Statement ',
            con: 'We will notify you if there is any change to this Privacy Statement ',
            is_fold: false,
            sec_list: [
              { con: 'Widi reserves the right to modify this Privacy Statement at any time without notice. The Privacy Statement posted at any time via our Website or shall be deemed to be the Privacy Statement then in effect. ' }
            ]
          }
        ]
      },
      termsData: {
        tit: 'Widi’s User Agreement',
        intro: `Widi Pte Limited (“<b>Widi</b>” “we,” or “us”, together with our affiliates and subsidiaries, “<b>Widi</b>”, “we”, “us” or “our” and terms of similar meaning) provides its services and products via its widi.com website (the <b>“Website</b>”) and mobile applications or software (the "<b>Software</b>")(the “<b>Services</b>”) subject to the terms and conditions of use, and all policies and guidelines referenced herein (the “<b>Terms</b>”) under this User Agreement (the <b>“Agreement”</b>). <br/><br/>By using the Services, you have read, understood and agreed to be bound by the Terms of this Agreement and any terms and conditions under our Privacy Statement including any cookies policy herein. `,
        key: 'terms',
        list: [
          {
            tit: 'Definitions',
            con: '',
            sec_list: [
              {
                con: '1.1	 &nbsp;&nbsp; In this Agreement the following definitions apply unless the context states otherwise:'              },

              {
                con: '“<b>Fee</b>” means any fee to be paid by Subscriber to purchase the tokens to access and use the Services;'
              },
              {
                con: '“<b>Login Credential</b>” means the user names, passwords, tokens, or other login credentials that are used to activate, access or use the Services;'
              },
              {
                con: '“<b>Order Form</b>” means the form that is completed by you as part of the transaction process to subscribe the Services;'
              },
              {
                con: '“<b>Software</b>” means the Widi’s website, application or software to allow the Services to be made available for access;'
              },
              {
                con: '“<b>Subscriber</b>” or “<b>You</b>”, “<b>your</b>”, or similar words means a person, sole trader, partnership, company or accountancy practice which has a subscription of Widi’s Services. Generally, this will be your own business, or the business you are representing on the order form;'
              },
              {
                con: '“<b>Subscriber Content</b>” means any content, data, documents, images or information provided, entered or uploaded by you or any User of you while using the Services;'
              },
              {
                con: '“<b>Master User</b>” means the primary contact and account administrator of a Subscriber; and'
              },
              {
                con: '“<b>User</b>” means the individual authorised and registered by Subscriber or Master User to access and use the Services on behalf of the Subscriber or Master User, including the Subscriber and Master User themselves.'
              }
            ]
          },
          {
            tit: 'Services',
            con: '',
            sec_list: [
              {
                con: '2.1 &nbsp;&nbsp; You, as the Subscriber, by registering for and using the Services, agree to this Agreement and represent that you have proper authorization to bind the Master Users or any Users to this Agreement.'
              },
              {
                con: '2.2 &nbsp;&nbsp; If you are a Master User, by using the Services or allowing any of the Subscriber or Users to use the Services, you agree to this Agreement on behalf of the Subscriber.'
              },
              {
                con: '2.3 &nbsp;&nbsp; If you are a User, by using the Services you agree to this Agreement and are likewise agreeing not to take any actions (or omit to take any actions) that would cause the Subscriber to violate this Agreement.'
              },
              {
                con: '2.4 &nbsp;&nbsp; The Services may continue to change over time as we refine and add more features. We may stop, suspend, or modify the Services at any time without prior notice to you. We may also remove any content from our Services at our discretion.'
              },
              {
                con: '2.5 &nbsp;&nbsp; You agree that The Privacy Statement is incorporated into this Agreement. If you choose to use the Services without blocking or disabling cookies, you consent to our use of these cookies and to our use in accordance with our Privacy Statement.'
              }
            ]
          },
          {
            tit: 'Fees',
            con: '',
            sec_list: [
              {
                con: '3.1 &nbsp;&nbsp; Fees for the Services are described on the Website. '
              },
              {
                con: '3.2 &nbsp;&nbsp; Subscriber is responsible for providing complete and accurate billing and contact information to Widi.'
              },
              {
                con: '3.3 &nbsp;&nbsp; All Fee is non-refundable for any reason, including if either of us terminate this Agreement. Widi reserves the right, in our sole discretion, to modify the Fee and Services at any time.'
              },
              {
                con: '3.4 &nbsp;&nbsp; Subscriber is responsible for all taxes. Widi will charge the Subscriber for any VAT tax if VAT is applicable. If Subscriber is required by law to withhold any taxes, Subscriber must provide Widi with an official tax receipt or other appropriate documentation.'
              }
            ]
          },
          {
            tit: 'Ownership of and Responsibility for Content',
            con: '',
            sec_list: [
              {
                con: '4.1 &nbsp;&nbsp; Widi’s only right to Subscriber Content is the limited licenses to it granted in this Agreement.'
              },
              {
                con: '4.2 &nbsp;&nbsp;Subscriber Content is the Subscriber’s sole responsibility. You agree that Widi is not responsible for maintaining and protecting all Subscriber Content and Widi will not be liable for any loss or corruption of Subscriber Content, or for any costs or expenses associated with backing up or restoring any Subscriber Content.'
              },
              {
                con: '4.3 &nbsp;&nbsp; You further agree that Widi has no responsibility or liability for any loss or damage your Subscriber Content may cause to you or other entities or people. Although we have no obligation to do so, we have the absolute discretion to remove, screen or edit without notice any Subscriber Content posted or stored on the Services, and we may do this at any time and for any reason.'
              },
              {
                con: '4.4 &nbsp;&nbsp; You are solely responsible for maintaining copies of and replacing any Subscriber Content you post or store on the Services. If you authorize third parties to access your Subscriber Content through the Services, you agree that we are permitted to provide to them the Subscriber Content, and also agree that we have no responsibility or liability for their use of such Subscriber Content.'
              }
            ]
          },
          {
            tit: 'Limited License of Subscriber Content',
            con: '',
            sec_list: [
              {
                con: '5.1 &nbsp;&nbsp; We do not claim any ownership interest in your Subscriber Content, but we do need the right to use your Subscriber Content to the extent necessary to operate the Website or provide the Services, now and in the future. Therefore, by posting, modifying, or distributing Subscriber Content to or through our Website or Softwares, you:- ',
                third_list: [
                  {
                    con: '(a) 	grant Widi and our affiliates and subsidiaries a non-exclusive, royalty-free, transferable right to use, display, perform, reproduce, distribute, publish, modify, adapt, translate, and create derivative works from such Subscriber Content, in the manner in and for the purposes for which the Services from time to time use such Subscriber Content;'
                  },
                  {
                    con: '(b) 	represent and warrant that (i) you own and control all of the rights to the Subscriber Content that you post or otherwise distribute, or you otherwise have the lawful right to post and distribute that Subscriber Content, to or through the Services; and; (ii) the use and posting or other transmission of such Subscriber Content does not violate any Terms under this Agreement and will not violate any rights of or cause injury to any person or entity.'
                  }
                ]
              },
              {}
            ]
          },
          {
            tit: 'Widi’s Property',
            con: '',
            sec_list: [
              {
                con: '6.1 &nbsp;&nbsp; Widi owns all property rights, including intellectual property rights in the Software and Website (including the content). You acknowledge that all intellectual property rights in the Software and in the data generated through use of the Services are owned by Widi. You acknowledge that some components used in the Software are licensed from third parties and agree to the terms and conditions of these third-party service providers.'
              },
              {
                con: '6.2 &nbsp;&nbsp; This Agreement does not grant you any right, title, or interest in the Services, Software, Website nor any content in the Services. When Users send us feedback, you agree that Widi may use, publish, or make available publicly any feedback, comments, or suggestions you send us or post in our publications, Website, forums or any social media without any obligation to you. The Software, Website and other technology Widi uses to provide the Services are protected by copyright, trademark, and other laws of Hong Kong and any other foreign countries. This Agreement does not grant you any rights to use the Widi trademarks, logos, domain names, or other brand features.'
              },
              {
                con: '6.3 &nbsp;&nbsp; The Services are for the Users’ use only. You may not resell, lease or provide them in any other way to anyone else. You may not distribute the information (in any form) obtained from the Software or Website or your use of the Services to third parties, “mirror” or include the information on your own server or modify or re-use the information without our prior written consent.'
              }
            ]
          },
          {
            tit: 'Account Security',
            con: '',
            sec_list: [
              {
                con: "7.1 &nbsp;&nbsp; Users are responsible for safeguarding the Login Credentials and Users agree not to disclose their Login Credentials. The Login Credentials are critical to the security of Users' data or Subscriber Content. Subscribers are responsible for ensuring that their Users safeguard their Login Credentials. Users, and the Subscribers that oversee them, are responsible for any activity using their accounts, whether or not they authorized that activity. You should immediately notify us via email of any unauthorized use of any account . You acknowledge that if you wish to protect your transmission of data or files to or from us, it is your responsibility to use a secure, encrypted connection to communicate with the Services. You also acknowledge that communications over the Internet may be subject to breaches of security and that the submission of your Subscriber Content or other information may not be secure."
              }
            ]
          },
          {
            tit: 'Software and Updates',
            con: '',
            sec_list: [
              {
                con: '8.1 &nbsp;&nbsp; Some use of our Services may require you to download the Software. We hereby grant you a limited, non-exclusive, non-transferable, revocable license to use the Software, solely to access the Services. Your license to use the Software is automatically revoked if you violate any Terms under this Agreement.'
              },
              {
                con: '8.2 &nbsp;&nbsp; We hereby reserve all rights not expressly granted under this Agreement. You must not reverse engineer or decompile the Software, nor attempt to do so, nor assist anyone else to do so. Our Services may update the Software on your device automatically when a new version is available.'
              }
            ]
          },
          {
            tit: 'Acceptable Use Policy',
            con: '',
            sec_list: [
              {
                con: '9.1 &nbsp;&nbsp; You will not, and will not attempt to, misuse the Services. In particular, you must not, and must not attempt to, use the Services to do the following things:',
                third_list: [
                  {
                    con: '(a) 	probe, scan, or test the vulnerability of any system or network;'
                  },
                  {
                    con: '(b)	breach or otherwise circumvent any security or authentication measures;'
                  },
                  {
                    con: '(c)	access, tamper with, or use non-public areas of the Service, shared areas of the Service you have not been invited to, or Widi’s (or our service providers’) computer systems;'
                  },
                  {
                    con: '(d)	interfere with or disrupt any user, host, or network, for example by sending a virus, overloading, flooding, spamming, or mail-bombing any part of the Services;'
                  },
                  {
                    con: '(e)	plant malware or otherwise use the Services to distribute malware; '
                  },
                  {
                    con: '(f)	access or search the Services by any means other than our publicly supported interfaces (for example, “scraping”); '
                  },
                  {
                    con: '(g)	send unsolicited communications, promotions or advertisements, or spam;'
                  },
                  {
                    con: '(h)	send altered, deceptive or false source-identifying information, including “spoofing” or “phishing”; '
                  },
                  {
                    con: '(i)	use the Services to produce products or services that compete with those offered by Widi; '
                  },
                  {
                    con: "(j) 	publish anything that is fraudulent, misleading, or infringes another's rights; "
                  },
                  {
                    con: '(k)	promote or advertise products or services other than your own without appropriate authorization; '
                  },
                  {
                    con: '(l)	impersonate or misrepresent your affiliation with any person or entity; or '
                  },
                  {
                    con: '(m)	violate the law in any way, or to violate the privacy of others, or to defame others.'
                  }
                ]
              },
              {
                con: '9.2 &nbsp;&nbsp; You have sole responsibility for the accuracy and reliability of your Subscriber Content. You retain ownership of any copyright, trademarks, database rights and any other intellectual property rights in your Subscriber Content . Intellectual property rights in your Subscriber Content will not be transferred to us. '
              },
              {
                con: '9.3 &nbsp;&nbsp; You have sole responsibility for ensuring that the use of the Services and the storage of Subscriber Content within the Software or via our Website complies with all required laws and regulations for the jurisdiction in which you operate and for your personal circumstances. We make no representations or guarantees that data recorded and stored in the Software or via our Website will be compliant with laws and regulations applicable to you.'
              },
              {
                con: '9.4 &nbsp;&nbsp; Except required by any applicable law, you should not upload any "sensitive personal data” to the Services, which may include, but is not limited to, information about yourself or any another person that may reveal racial or ethnic origin, political opinions, religious or philosophical beliefs, or trade union membership, and the processing of genetic data, biometric data for the purpose of uniquely identifying a natural person, data concerning health or data concerning a natural person’s sex life or sexual orientation (“<b>Sensitive Personal Data</b>”). If you upload any Sensitive Personal Data to the Services, you must notify us and provide us with the legal justifications for doing so via email immediately. At Widi’s absolute discretion, Widi may take any actions to any Sensitive Personal Data uploaded by you, including but not limited to encrypt, depersonalise, anonymise, redact, destroy, delete such Sensitive Personal Data. Notwithstanding the foregoing, Widi is not responsible for any Sensitive Personal Data uploaded to the Services and is under no obligation to ensure that Sensitive Personal Data is not uploaded to the Services.'
              },
              {
                con: '9.5 &nbsp;&nbsp; The Services are not intended for use by persons under the age of 18, and Subscriber will ensure that it does not allow any person under 18 to use the Services. Subscriber will promptly notify Widi of any unauthorized use of, or access to, the Services. '
              }
            ]
          },
          {
            tit: 'Intellectual Property Rights',
            con: '',
            sec_list: [
              {
                con: '10.1 &nbsp;&nbsp; All your Subscriber Content must not violate any intellectual property rights of any third parties. Should there be any alleged copyright infringement of your Subscriber Content, Widi reserves the right to delete or disable content alleged to be infringing and to terminate repeat infringers. '
              }
            ]
          },
          {
            tit: 'Third-party Content',
            con: '',
            sec_list: [
              {
                con: '11.1 &nbsp;&nbsp; The Services and the Website may contain links to third-party websites or resources. Widi does not endorse and is not responsible or liable for their availability, accuracy, content, products, or services. You are solely responsible for your use of any such websites or resources.'
              }
            ]
          },
          {
            tit: 'Termination and Suspension',
            con: '',
            sec_list: [
              {
                con: '12.1 &nbsp;&nbsp; Subscribers or individual Users may stop using our Services any time. Before your voluntary termination, you are responsible for retrieving all of your Subscriber Content from our Services. '
              },
              {
                con: '12.2 &nbsp;&nbsp; Widi reserves the right to suspend or end the Services at any time, with or without cause, and with or without notice if you are not complying with the Terms under this Agreement, or use the Services in any way that would cause us legal liability or disrupt others’ use of the Services.'
              },
              {
                con: '12.3 &nbsp;&nbsp; Without limiting any other right of termination under this Agreement, Widi may terminate your Services immediately if: ',
                third_list: [
                  {
                    con: '(a)	you are in breach of this Agreement;'
                  },
                  {
                    con: '(b)	the User allows their Login Credential to be shared or used by another person; '
                  },
                  {
                    con: '(c)	you stop or suspend or threaten to stop or suspend payment of all or a class of your debts; or'
                  },
                  {
                    con: '(d)	you are insolvent, have an administrator appointed, are wound up or an application is made to wind you up.'
                  }
                ]
              },
              {
                con: '12.4 &nbsp;&nbsp; No refund if this Agreement or Services is terminated under Clause 12.3. '
              },
              {
                con: '12.5 &nbsp;&nbsp;There may be occasions when our Services may be suspended or interrupted, including, without limitation, for scheduled maintenance or upgrades, for emergency repairs, or due to failure of telecommunications links and/or equipment. It is your responsibility to maintain your own backup of your data. You acknowledge that Widi does not have any responsibility to back up your Subscriber Content. You are responsible for maintaining your own backup of your Subscriber Content and other data.'
              }
            ]
          },
          {
            tit: 'Indemnification',
            con: '',
            sec_list: [
              {
                con: "13.1 &nbsp;&nbsp; Subscriber will indemnify, defend, and hold harmless Widi from and against all liabilities, damages, and costs (including settlement costs and reasonable attorneys' fees) arising out of a third party claim, suit, action or proceeding regarding: (a) Subscriber Content; (b) Subscriber's use of the Services in violation of the Terms under this Agreement; (c) Subscriber’s uploading of Sensitive Personal Information to the Services; (d) Subscriber’s or its Users’ disclosure of or failure to protect the Login Credentials; or (e) use of the Services by Subscriber’s Users."
              }
            ]
          },
          {
            tit: 'No Warranties',
            con: '',
            sec_list: [
              {
                con: '14.1 &nbsp;&nbsp; You agree and acknowledge that the Services and Software are provided “as is”, at your own risk, without express or implied warranty or condition of any kind. we also disclaim any warranties of merchantability, fitness for a particular purpose or non-infringement. Widi will have no responsibility for any harm to your computer system, loss or corruption of data, or other harm that results from your access to or use of the Services or Software. You are fully responsible for securing and backing up your own Subscriber Content and other data. Widi does not warrant that the operation of our Services will be error-free, timely, reliable, entirely secure, virus-free or available (especially since our Services depend on the reliability of the Internet and your use of your own personal device to access the Services) or uninterrupted. The information in, and obtained from, the Services, Software or Website may include errors and Widi makes no warranty that the information in or obtained through use of the Services is error free. Widi disclaims all liability (including for negligence) for your acting or relying on any inaccurate information supplied by us in connection with our provision of the Services.'
              },
              {
                con: '14.2 &nbsp;&nbsp; Widi is not responsible in any way for any professional services (including, but not limited to, attestation services, audits, and tax preparation or any other related services provided by Widi) that Subscribers or Users perform using our Services, and we are not responsible for ensuring that our tools are used correctly or appropriately within the context of any particular services rendered. Subscribers and Users must always rely on their own professional judgments when using the Services, and will neither inquire nor rely upon Widi for any tax, accounting, legal, or other professional or expert advice of any kind.'
              },
              {
                con: '14.3 &nbsp;&nbsp; The Subscriber and Users agree and acknowledge that the Services is not a substitute for a professional accountant and any information presented and the Services does not constitute accounting advice. The use of the Services does not relieve Subscriber or Users of responsibility for the preparation, content, accuracy (including computational accuracy), and review of User Content provided by you while using the Services or any other work product generated while using the Services.'
              }
            ]
          },
          {
            tit: 'Limitation of Liability',
            con: '',
            sec_list: [
              {
                con: '15.1 &nbsp;&nbsp; To the fullest extent permitted by law, in no event will Widi, its affiliates, officers, employees, agents, suppliers or licensors be liable for (a) any indirect, special, incidental, punitive, exemplary or consequential (including loss of use, data, business, or profits) damages, regardless of legal theory, whether or not Widi has been warned of the possibility of such damages, and even if a remedy fails of its essential purpose; (b) aggregate liability for all claims relating to the services more than the greater of US$100 or the amounts paid by you to Widi for the past three months of the services in question, whichever is lower. '
              }
            ]
          },
          {
            tit: 'Force Majeure',
            con: '',
            sec_list: [
              {
                con: '16.1 &nbsp;&nbsp; Widi will not be liable for failure or delay in performance to the extent caused by circumstances beyond its reasonable control, including, but not limited to, acts of god, telecommunications failure, or theft or destruction of our services.'
              }
            ]
          },
          {
            tit: 'Confidential Information',
            con: '',
            sec_list: [
              {
                con: '17.1 &nbsp;&nbsp; Subscriber and all Users agree not to use any Confidential Information (as hereinafter defined) disclosed to it by us for its own use or for any purpose other than to assist in the Subscriber’s auditing processes. Subscriber and all Users shall not disclose or permit disclosure of any Confidential Information to third parties. Subscriber and all Users agree that they shall take reasonable measures to protect the secrecy of and avoid disclosure or use of Confidential Information in order to prevent it from falling into the public domain or the possession of persons other than those persons authorized under this Agreement to have any such information.  Such measures shall include the degree of care that Subscriber utilizes to protect its own Confidential Information of a similar nature.  Subscriber agrees to notify us of any misuse, misappropriation or unauthorized disclosure of Confidential Information which may come to Subscriber’s attention. If Subscriber becomes legally compelled to disclose any Confidential Information, other than pursuant to a confidentiality agreement, Subscriber will provide us prompt written notice of such disclosure and will assist us in seeking a protective order or another appropriate remedy.  If we waive Subscriber’s compliance with this Section or fail to obtain a protective order or other appropriate remedy, Subscriber will furnish only that portion of the Confidential Information that is legally required to be disclosed;provided that any Confidential Information so disclosed shall maintain its confidentiality protection for all purposes other than such legally compelled disclosure.'
              },
              {
                con: '17.2 &nbsp;&nbsp; Subscriber and all Users agree that any violation or threatened violation of these provisions related to the use and disclosure of Confidential Information will cause irreparable injury to Widi, entitling Widi to obtain injunctive relief in addition to all legal remedies without showing or proving any actual damage and without any bond being required to be posted.'
              },
              {
                con: '17.3 &nbsp;&nbsp; “<b>Confidential Information</b>” means any oral, written, graphic or machine-readable information, technical data or know-how, including, but not limited to, that which relates to patents, patent applications, research, product plans, products, developments, inventions, processes, designs, drawings, engineering, formulae, markets, software (including source and object code), computer programs, algorithms, interfaces, inventions, processes, work flows, business plans, agreements with third parties, services, and customers, whether or not designated as “confidential” at the time of disclosure. Confidential Information shall include information disclosed by us before the date Subscriber first subscribed, but shall not include information that: (a) was publicly known or made generally available without a duty of confidentiality prior to the time of disclosure to Subscriber by us; (b) becomes publicly known or made generally available without a duty of confidentiality after disclosure to Subscriber by us through no action or inaction of Subscriber; or (c) is in the rightful possession of Subscriber without confidentiality obligations at the time of disclosure by us to Subscriber as shown by Subscriber’s then-contemporaneous written files and records kept in the ordinary course of business.'
              }
            ]
          },
          {
            tit: 'Modifications',
            con: '',
            sec_list: [
              {
                con: '18.1 &nbsp;&nbsp; We may revise this Agreement from time to time and the most current version will always be posted on our website. If a revision, in our sole discretion, is material, we will notify the Master User via email to the email address associated with the Master User’s account. Other changes may be posted to our terms page, so please check that page regularly. If a User affiliated with a Subscriber continues to use the Services after revisions become effective, the Subscriber and the User each agree to be bound by the revised Terms. If you do not agree to the new terms, please stop using the Services and stop your Users from using the Service.'
              }
            ]
          },
          {
            tit: 'Assignment',
            con: '',
            sec_list: [
              {
                con: '19.1 &nbsp;&nbsp; You may not assign any of your rights in this Agreement, and any such attempt is void. Widi may assign its rights, with or without notice to you, to any of its affiliates or subsidiaries, or to any successor in interest of any business associated with the Services.'
              }
            ]
          },
          {
            tit: 'No Partnership',
            con: '',
            sec_list: [
              {
                con: '20.1 &nbsp;&nbsp; Widi and you are not legal partners or agents; instead, our relationship is that of independent contractors.'
              }
            ]
          },
          {
            tit: 'Governing Law',
            con: '',
            sec_list: [
              {
                con: '21.1 &nbsp;&nbsp; This Agreement and the use of the Services and Software will be governed by the law of Hong Kong and subject to the non-exclusive jurisdiction of Hong Kong.'
              }
            ]
          },
          {
            tit: 'Entire Agreement',
            con: '',
            sec_list: [
              {
                con: '22.1 &nbsp;&nbsp; This Agreement constitutes the entire and exclusive agreement between you and Widi with respect to the Services, and supersedes and replaces any other agreements, terms and conditions applicable to the Services. This Agreement creates no third party beneficiary rights. '
              }
            ]
          },
          {
            tit: 'Notice',
            con: '',
            sec_list: [
              {
                con: '23.1 &nbsp;&nbsp; We may send you, in electronic form, information about our Services, additional information, and information the law requires us to provide. We may provide required information to you by email at the address you specified when you signed up for our Services or by access to a website that we identify. Notices emailed to you will be deemed given and received when the email is sent. If you don’t consent to receive notices electronically, you must stop using our Services. You must provide legal notice to us via email to <a href="mailto:support@thewidi.com">support@thewidi.com</a>, with a duplicate copy sent via registered mail, return receipt requested, to the mailing address specified on our website. Any such notice, in either case, must specifically reference that it is a notice given under this Agreement.'
              }
            ]
          },
          {
            tit: 'Severability',
            con: '',
            sec_list: [
              {
                con: '24.1 &nbsp;&nbsp; This Agreement applies to the maximum extent permitted by relevant law. If a provision is found unenforceable, the remaining provisions of this Agreement will remain in full effect and an enforceable term will be substituted reflecting our intent as closely as possible. '
              }
            ]
          },
          {
            tit: 'Waiver',
            con: '',
            sec_list: [
              {
                con: '25.1 &nbsp;&nbsp; Widi’s failure to enforce a provision is not a waiver of its right to do so later. '
              }
            ]
          }
        ]
      }
    };
  },
  computed: {
    pageData () {
      var name = this.$route.query.name;
      return name === "privacy" ? this.privacyData : this.termsData
    },
  },
  methods: {
    toggleFold (index) {
      const val = this.pageData.list[index].is_fold
      this.$set(this.pageData.list[index], 'is_fold', !val)
    },
  },
  mounted () {
    // this.$refs.privacy_sec_point.scrollIntoView()
    if (this.$route.query.anchor) {
      this.$set(this.privacyData.list[1], 'is_fold', true)
      this.$nextTick(() => {
        document.getElementById(this.$route.query.anchor).scrollIntoView(true);
      })
    }
  }

};
</script>

<style lang="scss">
.terms {
  max-width: 940px;
  margin: 0 auto;
  padding: 0 20px;
  line-height: 24px;
  .terms-list {
    margin: 90px 0;
    & > li:first-child > h1 {
      font-size: 48px;
    }
    & > li {
      margin-top: 50px;
      .tit {
        font-size: 36px;
        line-height: initial;
      }
      .sm-tit {
        font-size: 30px;
      }
      .con {
        padding-top: 20px;
        font-size: 18px;
        color: rgba(35, 31, 32, 0.8);
      }
      .other-list {
        padding-left: 16px;
        & > li {
          list-style: unset;
          padding-top: 10px;
        }
      }
      .green {
        color: #3d9da2;
      }
    }
  }
}
.pt-tank {
  padding: 50px 0;
  .pt-tit {
    font-size: 38px;
    line-height: 48px;
    font-family: "InterBold";
    letter-spacing: -1px;
    margin-bottom: 20px;
  }
  .pt-main {
    margin-top: 20px;
    .bold {
      font-family: "InterBold";
    }
    .num {
      display: inline-block;
      margin-right: 3%;
      width: 15px;
    }
    .first-con {
      padding-left: 4.5%;
      margin-top: 20px;
    }
    .fold-btn {
      border: 1px solid #23bd8b;
      border-radius: 4px;
      color: #23bd8b;
      padding: 10px 35px 10px 20px;
      margin: 20px 0;
      margin-left: 4.5%;
      position: relative;
      width: 110px;
      .btn-icon {
        position: absolute;
        right: 10px;
        transition: all 0.5s;
      }
      .active-icon {
        transform: rotate(180deg);
      }
    }

    .fold-tank {
      .sec-con,
      .third-con,
      .fourth-con {
        margin: 15px 0;
      }
      .sec-con {
        padding-left: 4.5%;
      }
      .third-con {
        padding-left: 8%;
      }
      .fourth-con {
        padding-left: 11%;
      }
      .active-fold {
        height: auto;
        overflow: visible;
      }
      .hidden-fold {
        height: 0;
        transition: all 0.3s;
        overflow: hidden;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .terms {
    .terms-list {
      margin: 0;
      li:first-child > h1 {
        font-size: 36px;
      }
      & > li {
        margin-top: 35px;
        .tit {
          font-size: 30px;
        }
        .sm-tit {
          font-size: 24px;
        }
      }
    }
  }
}
</style>

